import {spinnerSvg as Icon__small__spinnerSvg} from '../Icon__small/Icon__small--spinner.js';

export var spinner = {
  name: 'spinner',
  category: 'icon',
  colorable: true,
  svg: Icon__small__spinnerSvg,
};
